"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _fileSaver = require("file-saver");

var _axios = _interopRequireDefault(require("axios"));

var _auth = require("@/utils/auth");

var _elementUi = require("element-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var baseURL = process.env.VUE_APP_BASE_API;
var _default = {
  name: function name(_name) {
    var _this = this;

    var isDelete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var url = baseURL + "/common/download?fileName=" + encodeURI(_name) + "&delete=" + isDelete;
    (0, _axios.default)({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + (0, _auth.getToken)()
      }
    }).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
        var isLogin, blob;
        return _index.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.blobValidate(res.data);

              case 2:
                isLogin = _context.sent;

                if (isLogin) {
                  blob = new Blob([res.data]);

                  _this.saveAs(blob, decodeURI(res.headers['download-filename']));
                } else {
                  _elementUi.Message.error('无效的会话，或者会话已过期，请重新登录。');
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  resource: function resource(_resource) {
    var _this2 = this;

    var url = baseURL + "/common/download/resource?resource=" + encodeURI(_resource);
    (0, _axios.default)({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + (0, _auth.getToken)()
      }
    }).then( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
        var isLogin, blob;
        return _index.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.blobValidate(res.data);

              case 2:
                isLogin = _context2.sent;

                if (isLogin) {
                  blob = new Blob([res.data]);

                  _this2.saveAs(blob, decodeURI(res.headers['download-filename']));
                } else {
                  _elementUi.Message.error('无效的会话，或者会话已过期，请重新登录。');
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  },
  zip: function zip(url, name) {
    var _this3 = this;

    var url = baseURL + url;
    (0, _axios.default)({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + (0, _auth.getToken)()
      }
    }).then( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee3(res) {
        var isLogin, blob;
        return _index.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.blobValidate(res.data);

              case 2:
                isLogin = _context3.sent;

                if (isLogin) {
                  blob = new Blob([res.data], {
                    type: 'application/zip'
                  });

                  _this3.saveAs(blob, name);
                } else {
                  _elementUi.Message.error('无效的会话，或者会话已过期，请重新登录。');
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
  },
  saveAs: function saveAs(text, name, opts) {
    (0, _fileSaver.saveAs)(text, name, opts);
  },
  blobValidate: function () {
    var _blobValidate = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee4(data) {
      var text;
      return _index.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return data.text();

            case 3:
              text = _context4.sent;
              JSON.parse(text);
              return _context4.abrupt("return", false);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", true);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 8]]);
    }));

    function blobValidate(_x4) {
      return _blobValidate.apply(this, arguments);
    }

    return blobValidate;
  }()
};
exports.default = _default;